var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarK = function SvgDefaultAvatarK(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_k_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_k_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 55.3c3.9 0 6.2-.4 6.2-1.6 0-.9-.9-1.2-3-1.3-.5-.2-.7-1.5-.7-4.5v-4.5c.6-.8 1.4-1.6 2.3-2.5 2.8 3.6 5.9 7.8 8.5 11.4 1.8 2.5 3.4 3 5.9 3 3.3 0 5-.6 5-1.6 0-.8-.9-1.2-3.5-1.3-.7-.2-1.8-1-3.2-2.8-2.9-3.7-5.9-7.6-9.3-12.1l2.2-2.2c4.2-4.3 6.5-6.8 8.2-7.1 2.4-.3 3.2-.8 3.2-1.5 0-1-2.1-1.7-5.9-1.7-3.9 0-6.3.5-6.3 1.7 0 .7.6 1.1 2.4 1.2.3.5-.3 1.7-2.6 4.3-2.9 3.2-5 5.4-6.8 7.2v-6.9c0-2.4.2-4.4.7-4.6 2.1-.1 3-.4 3-1.3 0-1.2-2.2-1.6-6.2-1.6-3.9 0-6.1.4-6.1 1.6 0 .9.9 1.2 3 1.3.5.2.7 2.2.7 4.6v15.4c0 3-.1 4.4-.7 4.5-2 .1-3 .4-3 1.3-.1 1.2 2.1 1.6 6 1.6z"
  })));
};
export default SvgDefaultAvatarK;